<template>
    <b-card no-body class="shadowed h-100 p-4 mx-2">
        <div class="d-flex flex-column justify-content-start mx-0 h-100">
            <b-img :src="logo" class="w-25 ml-auto mb-3" />
            <b-img :src="illustration" class="w-100" />
            <h6 class="mt-3 mb-4">{{ title }}</h6>
            <div class="mt-auto d-flex justify-content-end">
                <!--<b-button 
                    variant="link"
                    size="sm"
                    class="mr-2" 
                    @click="$emit('secondaryClicked')"> 
                    {{ buttonSecondaryText }}
                </b-button>-->
                <b-button
                    variant="secondary"
                    size="sm"
                    class="font-weight-bold"
                    @click="$emit('ctaClicked')"
                    :disabled="buttonDisabled"
                >
                    {{ buttonText }}
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        name: "StreamCard",
        props: {
            logo: String,
            title: String,
            illustration: String,
            buttonText: String,
            buttonDisabled: Boolean,
            buttonSecondaryText: String
        }
    }
</script>